
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.5","cy":"1.971","r":".208"}}),_c('circle',{attrs:{"cx":"7.5","cy":"1.971","r":".348"}}),_c('path',{attrs:{"d":"M7.498 13.443a.375.375 0 01-.375-.375v-1.85a.375.375 0 01.75 0v1.85a.375.375 0 01-.375.375zM9.793 13.443a.375.375 0 01-.375-.375v-1.85a.375.375 0 01.75 0v1.85a.375.375 0 01-.375.375zM5.206 13.443a.375.375 0 01-.375-.375v-1.85a.375.375 0 01.75 0v1.85a.375.375 0 01-.375.375z"}}),_c('path',{attrs:{"d":"M12.624 10.087c-.004-.028-.008-.056-.018-.082-.008-.022-.021-.042-.033-.063-.013-.021-.025-.043-.042-.063-.019-.02-.042-.035-.064-.051-.015-.011-.024-.025-.041-.034L8.395 7.691c.269-.245.444-.59.444-.981a1.34 1.34 0 00-.951-1.281v-.237h.184a.388.388 0 00.376-.292l.711-2.822a.38.38 0 00-.029-.267L8.419.368a.388.388 0 00-.348-.216H6.929a.387.387 0 00-.348.217L5.87 1.812a.393.393 0 00-.028.266L6.553 4.9a.387.387 0 00.376.292h.184v.568c0 .214.174.388.388.388a.564.564 0 11-.564.562.387.387 0 10-.775 0c0 .391.175.736.444.981L2.575 9.795c-.015.009-.025.021-.039.031-.024.018-.048.033-.067.055-.016.018-.027.038-.04.058a.396.396 0 00-.036.067c-.01.025-.012.052-.016.078-.003.02-.011.035-.011.055v4.322c0 .214.174.388.388.388h9.492a.388.388 0 00.388-.388v-4.322c0-.019-.008-.035-.01-.052zm-5.393-5.67l-.602-2.391L7.17.927h.66l.542 1.099-.602 2.391h-.539zM7.5 8.099l3.166 1.652H4.333L7.5 8.099zm4.358 5.974H3.142v-3.547h8.717v3.547z"}})])
          )
        }
      }
    